import { useEffect } from "react";

// Reliably injects a JSON-LD <script> into document.head (works regardless of
// react-helmet-async version, which does not portal <script> children to head).
export const JsonLd = ({ data }) => {
  const json = JSON.stringify(data);
  useEffect(() => {
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.text = json;
    document.head.appendChild(el);
    return () => {
      if (el.parentNode) el.parentNode.removeChild(el);
    };
  }, [json]);
  return null;
};

export default JsonLd;
